// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmationModal-cls1_mQT","cls2":"ConfirmationModal-cls2_k7j ConfirmationModal-cls1_mQT"};